<template>
    <div class="end-intervention grid gap-2">
        <div>
            <label class="label" >Nom Detenteur</label>
            <input class="input" title="name" type="text" name="_det_nom" id="_det_nom" v-model="infosDet.nom_signataire" @input="updateIsValid" maxlength="255">
        </div>
        <div>
            <label class="label" >Fonction</label>
            <input class="input" title="function" type="text" name="_det_qualite" id="visa_det_qualite" v-model="infosDet.fonction_signataire" @input="updateIsValid" maxlength="255">
        </div>
    </div>
</template>

<script>
    import SignatureModal from '../../../common/SignatureModal.vue'

    export default {

        data() {
            return {
                showModal: false,
                isValid: null
            }
        },

        props: {
            infosDet: {
                nom_signataire: null,
                fonction_signataire: null
            },
        },

        methods: {

            updateIsValid() {


                if (!this.infosDet.nom_signataire && !this.infosDet.fonction_signataire) {
                    this.isValid = false;
                    document.getElementById('main-action').classList.add('disabled');
                    document.getElementById('clotureWithoutSignature').classList.remove('disabled');
                }else if(this.infosDet.nom_signataire && this.infosDet.fonction_signataire) {
                    this.isValid = true;
                    document.getElementById('main-action').classList.remove('disabled');
                    document.getElementById('clotureWithoutSignature').classList.add('disabled');
                }else if(!this.infosDet.nom_signataire || !this.infosDet.fonction_signataire){
                    this.isValid = false;
                    document.getElementById('main-action').classList.add('disabled');
                    document.getElementById('clotureWithoutSignature').classList.add('disabled');
                }

                this.$emit('infosDetUpdated', this.isValid)

                /*
                if( !this.infosDet.nom_signataire || !this.infosDet.fonction_signataire){
                    this.isValid = false;
                    document.getElementById('goto-finish').classList.remove('actif')
                } else {
                    this.isValid = true;
                    document.getElementById('goto-finish').classList.add('actif')
                }
                this.$emit('infosDetUpdated', this.isValid)
                }
                 */
            }

        },

        components: {
            SignatureModal
        }

    }
</script>



// WEBPACK FOOTER //
// ClientInfos.vue?735cc2b3